(function() {
    // 注册组件
    SR.component.extend('slider', slider);

    function slider() {
        // 'swiper-navy'
        var colors = ['swiper-orange', 'swiper-red', 'swiper-gold', 'swiper-purple', 'swiper-blue', 'swiper-orange', 'swiper-red', 'swiper-gold', 'swiper-purple', 'swiper-blue'];
        $('#swiper-slider').find('.guide-questions').each(function(index){
            if (colors[index]) {
                $(this).addClass(colors[index])
            }
        });
        var mySwiper = new Swiper('#swiper-slider', {
            effect: 'coverflow',
            centeredSlides: true,
            // loop: true,
            slidesPerView: 1.4,
            pagination : '.swiper-pagination',
            paginationClickable :true,
            coverflow: {
                rotate: 0,
                stretch: -45,
                depth: 80,
                modifier: 1
            },
            onInit: function(swiper){
                $('#swiper-appearance').animate({
                    opacity: 1
                });
            },
            onTouchStart: function() {
                SR.App.trigger('hideKeyboard');
            }
        });
    }
})();
